export default __webpack_public_path__ + "static/Enrolment_Form-397f2957797219e5953ab37d8b6b8499.pdf";